<template>
  <div class="home bg-light">
    <SiteNav :login-user="loginUser"/>
    <div class="container-fluid container-3xl py-4.5">
      <a
        id="gridjs-head-btn" class="btn btn-primary py-2 float-end"
        @click.prevent="showEditProjectModal(undefined)" role="button"
      >新增專案</a>
      <div id="gridjs-wrapper"></div>
    </div>
    <!-- 新增/編輯專案 modal start -->
    <div
      class="modal fade" id="edit-project-modal" tabindex="-1"
      data-bs-backdrop="static" data-bs-keyboard="false"
      aria-labelledby="edit-project-modal-label" aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen-md-down"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="edit-project-modal-label">
              {{ createOrUpdate ? '新增專案' : '編輯專案' }}
            </h5>
            <button
              type="button" class="btn-close"
              data-bs-dismiss="modal" aria-label="取消"
            ></button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <form class="row gx-4 gy-3">
                <div v-show="formErrors.length > 0" class="col-12">
                  <div class="alert alert-danger mb-0 d-flex align-items-center" role="alert">
                    <span class="me-12px"><i class="bi bi-exclamation-circle"></i></span>
                    <span>請輸入{{ formErrors.join('、') }}後，再重新送出</span>
                  </div>
                </div>
                <div class="col-12">
                  <label for="client-field" class="form-label">客戶</label>
                  <multiselect
                    v-model="selectedClient"
                    :options="clientsIncludingInternal"
                    label="name"
                    track-by="id"
                    :allow-empty="false"
                    :show-labels="false"
                    id="client-field"
                    ref="clientField"
                    placeholder="🔍  輸入客戶名稱 ..."
                    :max-height="160"
                    @search-change="updateNewClientOption"
                    :search-on-blur-deactivate="false"
                  >
                    <template slot="option" slot-scope="{ option }">
                      <div
                        class="d-flex-noimp align-items-center"
                        :id ="`client-label-${option.id}`"
                        :key="`client-label-${option.id}`"
                      >
                        <div
                          class="flex-grow-1 px-2.5 py-2"
                          @click="createClientIfNotExists(option)"
                        >
                          <span v-if="option.id !== -1">
                            {{ option.name }}
                          </span>
                          <span class="new-client-option" v-else>
                            <i class="bi bi-plus-lg"></i>&nbsp;&nbsp;新增客戶「{{ option.name }}」
                          </span>
                        </div>
                        <div
                          class="px-2.5 py-2"
                          v-if="option.id !== null && option.id !== -1"
                          @click.stop="activateClientInput(option)"
                        >
                          <i class="bi bi-pencil"></i>
                        </div>
                      </div>
                      <div
                        class="d-none-noimp input-group"
                        :id ="`client-input-${option.id}`"
                        :key="`client-input-${option.id}`"
                      >
                        <input
                          class="form-control"
                          type="text"
                          value=""
                          required
                          @click.stop="$event.target.focus()"
                        >
                        <button
                          class="btn btn-outline-secondary"
                          type="button"
                          @click.stop="updateClient(option.id)"
                        >
                          <i class="bi bi-check2"></i>
                        </button>
                        <button
                          class="btn btn-outline-secondary"
                          type="button"
                          @click.stop="deactivateClientInput(option.id)"
                        >
                          <i class="bi bi-x"></i>
                        </button>
                        <button
                          class="btn btn-outline-danger"
                          type="button"
                          @click.stop="deleteClient(option.id)"
                        >
                          <i class="bi bi-trash"></i>
                        </button>
                      </div>
                    </template>
                    <span slot="noResult">
                      找不到符合的客戶
                    </span>
                  </multiselect>
                </div>
                <div class="col-12 mb-6">
                  <label for="project-field" class="form-label">專案名稱</label>
                  <input
                    v-model="enteredProject"
                    type="text"
                    class="form-control"
                    id="project-field"
                    placeholder=""
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button" class="btn btn-link btn-link-danger"
              v-if="!createOrUpdate" @click.prevent="showDeleteProjectModal"
            >刪除專案</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">取消</button>
            <button
              type="button" class="btn btn-primary"
              @click.prevent="createOrUpdateProject"
            >{{ createOrUpdate ? '確定新增' : '儲存修改' }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增/編輯專案 modal end -->
    <!-- 刪除專案 modal start -->
    <div
      class="modal fade" id="delete-project-modal" tabindex="-1"
      data-bs-backdrop="static" data-bs-keyboard="false"
      aria-labelledby="delete-project-modal-label" aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable max-w-482px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="delete-project-modal-label">
              刪除專案「{{ deleteProjectModalLabel }}」
            </h5>
            <button
              type="button" class="btn-close"
              data-bs-dismiss="modal" aria-label="取消"
            ></button>
          </div>
          <div class="modal-body">
            <span class="d-inline-block mb-2">專案的成員名單也會一併刪除哦！</span><br>
            <span class="text-muted">開始刪除前，系統會自動檢查這個專案是否擁有時數，如果有的話，就無法刪除這個專案。</span>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">取消</button>
            <button
              type="button" class="btn btn-danger"
              @click.prevent="deleteProject"
            >確定刪除</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 刪除專案 modal end -->
    <!-- 專案成員列表 modal start -->
    <div
      class="modal fade" id="member-list-modal" tabindex="-1"
      data-bs-backdrop="static" data-bs-keyboard="false"
      aria-labelledby="member-list-modal-label" aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable
               modal-fullscreen-md-down max-w-300px"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="member-list-modal-label">
              {{ memberListModalLabel }} 的成員
            </h5>
            <button
              type="button" class="btn-close"
              data-bs-dismiss="modal" aria-label="取消"
            ></button>
          </div>
          <div class="modal-body pt-0">
            <div
              class="d-flex border-bottom-transparent"
              v-for="(member, idx) in members" :key="member.id"
              :class="{ 'border-bottom': (idx + 1 < members.length) || !isCandidateDropdownActive }"
            >
              <div class="flex-grow-1 p-2">
                {{ member.first_name }} {{ member.last_name }}
              </div>
              <div
                class="p-2" role="button"
                @click="showRemoveMemberModal(member.id, member.first_name, member.last_name)"
              >
                <i class="bi bi-person-dash"></i>
              </div>
            </div>
            <div
              class="d-flex border-bottom-transparent"
              v-if="members.length === 0"
            >
              <div class="flex-grow-1 p-2 text-center">
                沒有成員
              </div>
            </div>
            <div class="d-flex-noimp" v-show="!isCandidateDropdownActive">
              <div
                class="flex-grow-1 p-2 text-primary" role="button"
                @click="activateCandidateDropdown"
              >
                <i class="bi bi-person-plus"></i>&nbsp;&nbsp;加入新成員&nbsp;...
              </div>
            </div>
            <div v-show="isCandidateDropdownActive">
              <multiselect
                v-model="selectedCandidate"
                :options="candidates"
                :custom-label="({ first_name, last_name }) => `${first_name} ${last_name}`"
                track-by="id"
                :allow-empty="false"
                :show-labels="false"
                :close-on-select="true"
                placeholder="🔍  輸入成員 ..."
                class="candidate-dropdown"
                ref="candidateDropdown"
                @select="addMember"
                @close="deactivateCandidateDropdown"
                open-direction="above"
                :max-height="Math.max(40, Math.min(40 * members.length, 320))"
              >
                <span slot="noResult">找不到符合的成員</span>
                <span slot="noOptions">沒有還沒加入的成員</span>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 專案成員列表 modal end -->
    <!-- 移除專案成員 modal start -->
    <div
      class="modal fade" id="remove-member-modal" tabindex="-1"
      data-bs-backdrop="static" data-bs-keyboard="false"
      aria-labelledby="remove-member-modal-label" aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="remove-member-modal-label">
              讓 {{ removeMemberModalLabel }} 退出專案
            </h5>
            <button
              type="button" class="btn-close"
              data-bs-dismiss="modal" aria-label="取消"
            ></button>
          </div>
          <div class="modal-body">
            <span class="d-inline-block mb-2">退出後他/她就無法再填寫這個專案的時數囉！</span><br>
            <span class="text-muted">這個動作不會刪除他/她過去填寫的時數。</span>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">取消</button>
            <button type="button" class="btn btn-danger" @click.prevent="removeMember">確定</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 移除專案成員 modal end -->
    <!-- 無法刪除 toast start -->
    <div class="position-fixed top-0 start-50 translate-middle-x p-2 z-2k">
      <div
        id="constraint-violation-error"
        class="toast align-items-center toast-danger w-450px"
        role="alert" aria-live="assertive" aria-atomic="true"
      >
        <div class="d-flex">
          <div class="toast-body">
            <div class="d-flex align-items-center">
              <span class="me-12px"><i class="bi bi-exclamation-circle"></i></span>
              <span>無法刪除這筆紀錄，因為這筆紀錄已經在其他地方被使用</span>
            </div>
          </div>
          <button
            type="button" class="btn-close me-2 m-auto"
            data-bs-dismiss="toast" aria-label="關閉"
          ></button>
        </div>
      </div>
    </div>
    <!-- 無法刪除 toast end -->
    <!-- 發生錯誤 toast start -->
    <div class="position-fixed top-0 start-50 translate-middle-x p-2 z-2k">
      <div
        id="create-edit-delete-project-failed"
        class="toast align-items-center toast-danger"
        role="alert" aria-live="assertive" aria-atomic="true"
      >
        <div class="d-flex">
          <div class="toast-body">😭&nbsp;&nbsp;發生了一點錯誤，請稍後再試</div>
          <button
            type="button" class="btn-close me-2 m-auto"
            data-bs-dismiss="toast" aria-label="關閉"
          ></button>
        </div>
      </div>
    </div>
    <!-- 發生錯誤 toast end -->
    <!-- 正在載入專案 toast start -->
    <div class="position-fixed top-0 start-50 translate-middle-x p-2 z-2k">
      <div
        id="loading-projects"
        class="toast align-items-center toast-primary"
        role="alert" aria-live="assertive" aria-atomic="true"
        data-bs-autohide="false"
      >
        <div class="d-flex">
          <div class="toast-body">⏳&nbsp;&nbsp;正在載入專案&nbsp;...</div>
          <button
            type="button" class="btn-close me-2 m-auto"
            data-bs-dismiss="toast" aria-label="關閉"
          ></button>
        </div>
      </div>
    </div>
    <!-- 正在載入專案 toast end -->
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { Modal, Toast, Tooltip } from 'bootstrap';
import { Grid, h, html } from 'gridjs';
import 'gridjs/dist/theme/mermaid.css';
import SiteNav from '@/components/SiteNav.vue';
import { fetchApi } from '../utils/index';

export default {
  name: 'Projects',
  components: {
    Multiselect,
    SiteNav,
  },
  data() {
    /**
     * @typedef Project
     * @type {object}
     * @property {number} id
     * @property {string} name
     * @property {?number} client - client id
     * @property {number} is_active - 1 is true, 0 is false
     * @property {string} created_at - YYYY-MM-DD HH:MM:SS
     * @property {string} updated_at - YYYY-MM-DD HH:MM:SS
     */
    /**
     * @typedef ClientP
     * @type {object}
     * @property {?number} id
     * @property {string} name
     */
    /**
     * @typedef Member
     * @type {object}
     * @property {number} id
     * @property {string} first_name
     * @property {string} last_name
     */
    return {
      /** @type {Project[]} */
      projects: [],
      /** @type {ClientP[]} */
      clients: [],
      /**
       * members of a specific project
       * @type {Member[]}
       */
      members: [],
      /**
       * all active users in database
       * @type {Member[]}
       */
      users: [],
      /** @type {string} */
      enteredProject: '',
      /** @type {ClientP} */
      selectedClient: {
        id: -1,
        name: '搜尋或新增客戶 ...',
      },
      /** @type {Member} */
      selectedCandidate: {
        id: -1,
        first_name: '選擇新成員 ...',
        last_name: '',
      },
      /** @type {string[]} */
      formErrors: [],
      /**
       * true = create project,
       * false = update project
       * @type {boolean}
       */
      createOrUpdate: true,
      /** @type {string} */
      memberListModalLabel: '',
      /** @type {string} */
      removeMemberModalLabel: '',
      /** @type {boolean} */
      isCandidateDropdownActive: false,
      /** API action createProject/updateProject/deleteProject's parameters */
      modifyProjectParams: {
        id: -1,
      },
      /** API action addProjectMember/removeProjectMember's parameters */
      modifyMemberParams: {
        user: -1,
        project: -1,
      },
      /** @type {Grid} */
      grid: null,
      /** currently logged-in user */
      loginUser: {
        id: -1,
        first_name: '',
        last_name: '',
        role: '',
      },
    };
  },
  computed: {
    /**
     * all clients + internal client (AJA)
     * @type {ClientP[]}
     */
    clientsIncludingInternal() {
      const internalClient = { id: null, name: '( AJA 內部 )' };
      return [internalClient, ...this.clients];
    },
    /**
     * potential new members
     * ( candidates = users - members )
     * @type {Member[]}
     */
    candidates() {
      return this.users.filter((user) => this.members.every((member) => member.id !== user.id));
    },
    /** @type {string} */
    deleteProjectModalLabel() {
      const projectId = Object.prototype.hasOwnProperty.call(this.modifyProjectParams, 'id')
        ? this.modifyProjectParams.id
        : -1;
      const foundProject = this.projects.find((project) => project.id === projectId);
      return foundProject ? foundProject.name : '';
    },
  },
  methods: {
    /** @param {Error} error */
    displayErrorToast(error) {
      /* eslint-disable operator-linebreak, indent */
      const toastElement =
        (error.message.includes('Constraint Violation') || error.message.includes('(2.1)'))
        ? document.querySelector('#constraint-violation-error')
        : document.querySelector('#create-edit-delete-project-failed');
      /* eslint-enable operator-linebreak, indent */
      const toast = Toast.getOrCreateInstance(toastElement);
      toast.show();
      // eslint-disable-next-line no-console
      console.error('Error Details:', error);
    },
    renderGridjs() {
      const gridjsWrapper = document.querySelector('#gridjs-wrapper');
      const getClientName = (clientId) => {
        const foundClient = this.clients.find((client) => client.id === clientId);
        return foundClient ? foundClient.name : '( AJA 內部 )';
      };
      this.grid = new Grid({
        columns: [
          '專案名稱',
          '客戶',
          {
            id: 'is_active',
            name: html(`
              啟用&nbsp;
              <i class="bi bi-info-circle" data-bs-toggle="tooltip"
                 data-bs-placement="top" data-bs-html="true"
                 title="啟用這個專案，將允許專案<br>成員新增、編輯或刪除自己<br>在這個專案裡的時數紀錄。">
              </i>
            `),
            sort: false,
            width: '110px',
          },
          {
            name: '建立時間',
            width: '140px',
          },
          {
            name: '更新時間',
            width: '140px',
          },
          {
            id: 'actions',
            name: '',
            sort: false,
            width: '140px',
          },
        ],
        sort: true,
        search: true,
        pagination: {
          enabled: true,
          page: 0,
        },
        data: this.projects.map((project, idx) => [
          project.name,
          getClientName(project.client),
          h('div', { className: 'text-center' },
            h('input', {
              type: 'checkbox',
              id: `switch-${idx}`,
              className: 'switch-input',
              ...(project.is_active && { checked: 'checked' }),
              onChange: () => this.toggleProjectActiveState(`switch-${idx}`, project),
            }),
            h('label', {
              for: `switch-${idx}`,
              className: 'switch-label',
            }),
          ), // eslint-disable-line function-paren-newline
          project.created_at.substring(0, 10),
          project.updated_at.substring(0, 10),
          h('div', { className: 'text-center' },
            h('button', {
              className: 'btn btn-secondary btn-sm',
              onClick: () => this.showMemberListModal(project.id, project.name),
            }, h('i', { className: 'bi bi-people-fill' })),
            '\u2002',
            h('button', {
              className: 'btn btn-secondary btn-sm',
              onClick: () => this.showEditProjectModal(project),
            }, h('i', { className: 'bi bi-pencil-fill' })),
          ), // eslint-disable-line function-paren-newline
        ]),
        style: {
          table: {
            width: '100%',
          },
          th: {
            'border-left-width': '0',
            'border-right-width': '0',
          },
          td: {
            'border-left-width': '0',
            'border-right-width': '0',
            'white-space': 'nowrap',
          },
        },
        language: {
          search: {
            placeholder: '🔍  搜尋專案 ...',
          },
          sort: {
            sortAsc: '從 A 到 Z 排序',
            sortDesc: '從 Z 到 A 排序',
          },
          pagination: {
            previous: '⟨',
            next: '⟩',
            showing: ' ',
            of: '列（ 共',
            to: '–',
            results: '列 ）',
          },
          loading: '⏳  正在載入專案 ...',
          noRecordsFound: '找不到符合的專案',
          error: '😭  發生了一點錯誤，請稍後再試',
        },
      }).render(gridjsWrapper);
      const tooltipElement = document.querySelector('[data-bs-toggle="tooltip"]');
      Tooltip.getOrCreateInstance(tooltipElement);
      const gridjsHead = document.querySelector('.gridjs-head');
      const gridjsHeadBtn = document.querySelector('#gridjs-head-btn');
      gridjsHead.appendChild(gridjsHeadBtn);
    },
    /** @param {number} initialPageNo - initial page number, starts from 0 */
    updateGridjs(initialPageNo = 0) {
      const gridjsHeadBtn = document.querySelector('#gridjs-head-btn');
      const getClientName = (clientId) => {
        const foundClient = this.clients.find((client) => client.id === clientId);
        return foundClient ? foundClient.name : '( AJA 內部 )';
      };
      const totalPages = Math.ceil(this.projects.length / 10);
      this.grid.updateConfig({
        pagination: {
          enabled: true,
          page: Math.max(0, Math.min(initialPageNo, totalPages - 1)),
        },
        data: this.projects.map((project, idx) => [
          project.name,
          getClientName(project.client),
          h('div', { className: 'text-center' },
            h('input', {
              type: 'checkbox',
              id: `switch-${idx}`,
              className: 'switch-input',
              ...(project.is_active && { checked: 'checked' }),
              onChange: () => this.toggleProjectActiveState(`switch-${idx}`, project),
            }),
            h('label', {
              for: `switch-${idx}`,
              className: 'switch-label',
            }),
          ), // eslint-disable-line function-paren-newline
          project.created_at.substring(0, 10),
          project.updated_at.substring(0, 10),
          h('div', { className: 'text-center' },
            h('button', {
              className: 'btn btn-secondary btn-sm',
              onClick: () => this.showMemberListModal(project.id, project.name),
            }, h('i', { className: 'bi bi-people-fill' })),
            '\u2002',
            h('button', {
              className: 'btn btn-secondary btn-sm',
              onClick: () => this.showEditProjectModal(project),
            }, h('i', { className: 'bi bi-pencil-fill' })),
          ), // eslint-disable-line function-paren-newline
        ]),
      }).forceRender();
      const tooltipElement = document.querySelector('[data-bs-toggle="tooltip"]');
      Tooltip.getOrCreateInstance(tooltipElement);
      const gridjsHead = document.querySelector('.gridjs-head');
      gridjsHead.appendChild(gridjsHeadBtn);
    },
    /** @param {Project} [project] */
    showEditProjectModal(project) {
      if (project === undefined) {
        this.selectedClient = { id: -1, name: '搜尋或新增客戶 ...' };
        this.enteredProject = '';
        this.createOrUpdate = true; // create project
        this.modifyProjectParams.id = null;
      } else {
        this.selectedClient = (project.client)
          ? this.clients.find((client) => client.id === project.client)
          : { id: null, name: '( AJA 內部 )' };
        this.enteredProject = project.name;
        this.createOrUpdate = false; // update project
        this.modifyProjectParams.id = project.id;
      }
      this.formErrors = [];
      this.$refs.clientField.deactivate();
      const modalElement = document.querySelector('#edit-project-modal');
      const modal = Modal.getOrCreateInstance(modalElement);
      modal.show();
    },
    showDeleteProjectModal() {
      let modalElement;
      let modal;
      modalElement = document.querySelector('#edit-project-modal');
      modal = Modal.getOrCreateInstance(modalElement);
      modal.hide();
      modalElement = document.querySelector('#delete-project-modal');
      modal = Modal.getOrCreateInstance(modalElement);
      modal.show();
    },
    /** @param {string} searchQuery */
    updateNewClientOption(searchQuery) {
      // eslint-disable-next-line no-param-reassign
      searchQuery = searchQuery.trim();
      if (this.clientsIncludingInternal.some(
        (client) => client.id !== -1 && client.name === searchQuery,
      ) || searchQuery.length === 0) {
        this.clients = this.clients.filter((client) => client.id !== -1);
      } else {
        const newClient = this.clients.find((client) => client.id === -1);
        if (newClient) newClient.name = searchQuery;
        else this.clients.push({ id: -1, name: searchQuery });
      }
    },
    /** @param {ClientP} client */
    activateClientInput(client) {
      const label = document.querySelector(`#client-label-${client.id}`);
      label.style.display = 'none';
      const inputGroup = document.querySelector(`#client-input-${client.id}`);
      inputGroup.style.display = 'flex';
      const input = inputGroup.querySelector('input[type="text"]');
      input.value = client.name;
    },
    /** @param {number} clientId */
    deactivateClientInput(clientId) {
      const label = document.querySelector(`#client-label-${clientId}`);
      label.style.display = 'flex';
      const inputGroup = document.querySelector(`#client-input-${clientId}`);
      inputGroup.style.display = 'none';
    },
    showMemberListModal(projectId, projectName) {
      fetchApi('getUsers', { project: projectId })
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          this.members = data.results;
        })
        .catch((error) => {
          this.displayErrorToast(error);
        });
      this.memberListModalLabel = projectName;
      this.modifyMemberParams.project = projectId;
      this.modifyMemberParams.user = -1;
      const modalElement = document.querySelector('#member-list-modal');
      const modal = Modal.getOrCreateInstance(modalElement);
      modal.show();
      if (this.users.length === 0) {
        fetchApi('getAllUsers')
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            const allUsers = data.results;
            const activeUsers = allUsers.filter((user) => user.is_active);
            /* eslint-disable camelcase */
            this.users = activeUsers.map(({
              username,
              role,
              is_active,
              created_at,
              updated_at,
              ...otherProps
            }) => otherProps);
            /* eslint-enable camelcase */
          })
          .catch((error) => {
            this.displayErrorToast(error);
          });
      }
    },
    showRemoveMemberModal(memberId, memberFirstName, memberLastName) {
      let modalElement;
      let modal;
      modalElement = document.querySelector('#member-list-modal');
      modal = Modal.getOrCreateInstance(modalElement);
      modal.hide();
      this.removeMemberModalLabel = `${memberFirstName} ${memberLastName}`;
      this.modifyMemberParams.user = memberId;
      modalElement = document.querySelector('#remove-member-modal');
      modal = Modal.getOrCreateInstance(modalElement);
      modal.show();
    },
    activateCandidateDropdown() {
      this.selectedCandidate = {
        id: -1,
        first_name: '選擇新成員 ...',
        last_name: '',
      };
      this.isCandidateDropdownActive = true;
      this.$refs.candidateDropdown.activate();
    },
    deactivateCandidateDropdown() {
      this.isCandidateDropdownActive = false;
    },
    createOrUpdateProject() {
      const formErrors = [];
      if (this.selectedClient.id === -1) formErrors.push('客戶');
      if (this.enteredProject.length === 0) formErrors.push('專案名稱');
      if (formErrors.length > 0) {
        this.formErrors = formErrors;
        return;
      }
      this.formErrors = [];
      if (this.createOrUpdate === true) {
        // condition: create project
        this.modifyProjectParams = {
          ...this.modifyProjectParams,
          client: this.selectedClient.id,
          name: this.enteredProject,
        };
        fetchApi('createProject', this.modifyProjectParams)
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            return fetchApi('getAllProjects');
          })
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            this.projects = data.results;
            this.updateGridjs();
          })
          .catch((error) => {
            this.displayErrorToast(error);
          });
      } else {
        // condition: update project
        const foundProject = this.projects.find(
          (project) => project.id === this.modifyProjectParams.id,
        );
        this.modifyProjectParams = {
          ...this.modifyProjectParams,
          client: this.selectedClient.id,
          name: this.enteredProject,
          is_active: foundProject.is_active,
        };
        fetchApi('updateProject', this.modifyProjectParams)
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            return fetchApi('getAllProjects');
          })
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            const pageNo = this.findPageNo(this.modifyProjectParams.id);
            this.projects = data.results;
            this.updateGridjs(pageNo);
          })
          .catch((error) => {
            this.displayErrorToast(error);
          });
      }
      const modalElement = document.querySelector('#edit-project-modal');
      const modal = Modal.getOrCreateInstance(modalElement);
      modal.hide();
    },
    /**
     * @param {string} elementId
     * @param {Project} project
     */
    toggleProjectActiveState(elementId, project) {
      const checkbox = document.getElementById(elementId);
      const newProject = {
        ...project,
        is_active: checkbox.checked ? 1 : 0,
      };
      fetchApi('updateProject', newProject)
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          return fetchApi('getAllProjects');
        })
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          const pageNo = this.findPageNo(newProject.id);
          this.projects = data.results;
          this.updateGridjs(pageNo);
        })
        .catch((error) => {
          this.displayErrorToast(error);
        });
    },
    deleteProject() {
      fetchApi('deleteProject', this.modifyProjectParams)
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          return fetchApi('getAllProjects');
        })
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          const pageNo = this.findPageNo(this.modifyProjectParams.id);
          this.projects = data.results;
          this.updateGridjs(pageNo);
        })
        .catch((error) => {
          this.displayErrorToast(error);
        });
      const modalElement = document.querySelector('#delete-project-modal');
      const modal = Modal.getOrCreateInstance(modalElement);
      modal.hide();
    },
    /** @param {ClientP} selectedClient */
    createClientIfNotExists(selectedClient) {
      if (selectedClient.id === -1) {
        fetchApi('createClient', selectedClient)
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            return fetchApi('getAllClients');
          })
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            this.clients = data.results;
            this.selectedClient = this.clients.find(
              (client) => client.name === selectedClient.name,
            );
          })
          .catch((error) => {
            this.displayErrorToast(error);
          });
      }
    },
    /** @param {number} clientId */
    updateClient(clientId) {
      const inputGroup = document.querySelector(`#client-input-${clientId}`);
      const input = inputGroup.querySelector('input[type="text"]');
      if (input.reportValidity()) {
        const selectedClient = { id: clientId, name: input.value };
        this.deactivateClientInput(clientId);
        fetchApi('updateClient', selectedClient)
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            return fetchApi('getAllClients');
          })
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            this.clients = data.results;
            if (this.selectedClient.id === clientId) {
              this.selectedClient = selectedClient;
            }
            const pageNo = typeof this.modifyProjectParams.id === 'number'
              ? this.findPageNo(this.modifyProjectParams.id)
              : undefined;
            this.updateGridjs(pageNo);
          })
          .catch((error) => {
            this.displayErrorToast(error);
          });
      }
    },
    /** @param {number} clientId */
    deleteClient(clientId) {
      const selectedClient = { id: clientId, name: null };
      this.deactivateClientInput(clientId);
      fetchApi('deleteClient', selectedClient)
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          return fetchApi('getAllClients');
        })
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          this.clients = data.results;
          if (this.selectedClient.id === clientId) {
            this.selectedClient = { id: -1, name: '搜尋或新增客戶 ...' };
          }
        })
        .catch((error) => {
          this.displayErrorToast(error);
        });
    },
    /** @param {Member} selectedCandidate */
    addMember(selectedCandidate) {
      if (selectedCandidate.id > 0) {
        this.modifyMemberParams.user = selectedCandidate.id;
        fetchApi('addProjectMember', this.modifyMemberParams)
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            this.modifyMemberParams.user = -1;
            return fetchApi('getUsers', this.modifyMemberParams);
          })
          .then((data) => {
            if (data.status === -1) {
              this.$router.push('/login');
            }
            if (data.status !== 0) {
              throw new Error(`${data.message} (${data.status})`);
            }
            this.members = data.results;
          })
          .catch((error) => {
            this.displayErrorToast(error);
          });
      }
    },
    removeMember() {
      const modalElement = document.querySelector('#remove-member-modal');
      const modal = Modal.getOrCreateInstance(modalElement);
      modal.hide();
      fetchApi('removeProjectMember', this.modifyMemberParams)
        .then((data) => {
          if (data.status === -1) {
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          const projectId = this.modifyMemberParams.project;
          const foundProject = this.projects.find((project) => project.id === projectId);
          this.modifyMemberParams.project = -1;
          this.modifyMemberParams.user = -1;
          this.showMemberListModal(projectId, foundProject.name);
        })
        .catch((error) => {
          this.displayErrorToast(error);
        });
    },
    /**
     * 計算這個專案會出現在列表的第幾頁
     * @param {number} projectId - 專案的 ID
     * @returns {number|undefined}
     */
    findPageNo(projectId) {
      const idx = this.projects.findIndex((project) => project.id === projectId);
      const pageNo = Math.ceil((idx + 1) / 10) - 1;
      // we need to minus 1 because pageNo starts from 0
      return (pageNo >= 0) ? pageNo : undefined;
    },
  },
  mounted() {
    const toastElement = document.querySelector('#loading-projects');
    const loadingToast = Toast.getOrCreateInstance(toastElement);
    fetchApi('getLoggedInUser')
      .then((data) => {
        if (data.status === -1) {
          this.$router.push('/login');
        }
        if (data.status !== 0) {
          throw new Error(`${data.message} (${data.status})`);
        }
        const { results } = data;
        [this.loginUser] = results;
        loadingToast.show();
      })
      .then(() => Promise.all([
        fetchApi('getAllProjects'),
        fetchApi('getAllClients'),
      ]))
      .then((dataList) => {
        const resultsList = [];
        dataList.forEach((data) => {
          if (data.status === -1) {
            loadingToast.hide();
            this.$router.push('/login');
          }
          if (data.status !== 0) {
            throw new Error(`${data.message} (${data.status})`);
          }
          resultsList.push(data.results);
        });
        [this.projects, this.clients] = resultsList;
        this.renderGridjs();
        loadingToast.hide();
      })
      .catch((error) => {
        loadingToast.hide();
        this.displayErrorToast(error);
      });
  },
};
</script>

<style lang="scss">
@import "../utils/toggle-switch";
</style>

<style scoped lang="scss">
@import "~bootstrap/scss/bootstrap-grid";
.container-fluid {
  @include media-breakpoint-up(md) {
    padding-left: 48px;
    padding-right: 48px;
  }
}
.container-3xl {
  @media (min-width: 1441px) {
    max-width: 1440px;
  }
}
.d-flex-noimp {
  // without !important
  display: flex;
}
.d-none-noimp {
  // without !important
  display: none;
}
.border-bottom-transparent {
  border-bottom: 1px solid transparent;
}
.btn-link-danger {
  text-decoration: none;
  padding-left: 6px;
  padding-right: 6px;
  margin-right: auto;
  color: #dc3545;
  &:hover {
    color: #bb2d3b;
  }
}
::v-deep .gridjs-wrapper {
  @include media-breakpoint-up(xl) {
    th:nth-child(1), td:nth-child(1) {
      width: 30% !important;
    }
    th:nth-child(2), td:nth-child(2) {
      width: 20% !important;
    }
  }
}
::v-deep .multiselect__option {
  .d-flex-noimp,
  .d-none-noimp {
    margin: -12px;
    width: calc(100% + 24px);
    height: 40px;
  }
  .input-group .btn-outline-danger {
    border-color: #6c757d;
    &:hover {
      border-color: #dc3545;
    }
  }
}
::v-deep .new-client-option {
  color: #0069b7;
}
::v-deep .multiselect__option--highlight {
  .input-group {
    background: #fff;
  }
  .new-client-option {
    color: #fff;
  }
  &.multiselect__option--selected {
    background: #41b883;
    .input-group {
      background: #fff;
    }
    .new-client-option {
      color: #fff;
    }
  }
}
::v-deep .multiselect__option--selected {
  .input-group {
    background: #fff;
  }
}
.modal [role="button"] {
  &:hover {
    background: #e9ecef;
  }
}
::v-deep .gridjs-search-input {
  @include media-breakpoint-down(md) {
    width: 220px;
  }
}
</style>
